<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Organi Di Senso" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Gusto:</label>
                            <span v-if="isReadOnly">{{ jsonDataOrganiSenso.gusto }}</span>
                            <b-form-textarea v-else v-model="jsonDataOrganiSenso.gusto" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Olfatto:</label>
                            <span v-if="isReadOnly">{{ jsonDataOrganiSenso.olfatto }}</span>
                            <b-form-textarea v-else v-model="jsonDataOrganiSenso.olfatto" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Tatto:</label>
                            <span v-if="isReadOnly">{{ jsonDataOrganiSenso.tatto }}</span>
                            <b-form-textarea v-else v-model="jsonDataOrganiSenso.tatto" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Udito:</label>
                            <span v-if="isReadOnly">{{ jsonDataOrganiSenso.udito }}</span>
                            <b-form-textarea v-else v-model="jsonDataOrganiSenso.udito" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Vista:</label>
                            <span v-if="isReadOnly">{{ jsonDataOrganiSenso.vista }}</span>
                            <b-form-textarea v-else v-model="jsonDataOrganiSenso.vista" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataOrganiSenso.id" @click="onSaveOrganiSenso"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataOrganiSenso: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    tatto: "",
                    gusto: "",
                    olfatto: "",
                    vista: "",
                    udito: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataOrganiSenso: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaOrganiSenso: "/rsaschedarelazionesanitariaorganisenso",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaOrganiSenso() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaOrganiSenso + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaOrganiSensoSuccess, me.resultResponseSchedaRelazioneSanitariaOrganiSensoError);
        },

        resultResponseSchedaRelazioneSanitariaOrganiSensoSuccess(response) {
            let me = this;
            me.jsonDataOrganiSenso = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaOrganiSensoError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataOrganiSenso = {
                id: null,
                idAccettazione: this.idAccettazione,
                tatto: "",
                gusto: "",
                olfatto: "",
                vista: "",
                udito: "",
            };
        },

        onSaveOrganiSenso() {
            let me = this;
            me.jsonDataOrganiSenso.idAccettazione = me.idAccettazione;
            if (!me.jsonDataOrganiSenso.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaOrganiSenso, me.jsonDataOrganiSenso, me.saveSchedaRelazioneSanitariaOrganiSensoSuccessResponse, me.saveSchedaRelazioneSanitariaOrganiSensoErrorResponse);
        },
        saveSchedaRelazioneSanitariaOrganiSensoSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Organi di senso salvati con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaOrganiSensoErrorResponse() {
            console.error("Errore nel salvataggio organi di senso:");
        },
    },
};
</script>
